export default __webpack_public_path__ + "8191de023761b821f27b276b2cfb30b3.webp";